import React from 'react';
import { ACCESSORY_KEY, IMAGE, VIDEO } from '@yme/atoms/gallery/constants';
import { prepareVideo } from '@yme/atoms/gallery/helpers';
import { Image } from '@yme/atoms/image';
import { GalleryItemType } from '@yme/utils/constants';
const IMAGE_SORT_ORDER = [GalleryItemType.Action, GalleryItemType.Static, GalleryItemType.Detail];
function getImageWeight(rawUrl) {
    const url = rawUrl.toLowerCase();
    for (let i = 0; i < IMAGE_SORT_ORDER.length; i++) {
        if (url.includes(IMAGE_SORT_ORDER[i])) {
            return i;
        }
    }
    return -1;
}
export function isGalleryEmpty() {
    return false;
}
export function resolveRelatedImages(rawImages) {
    const seenKeys = new Set();
    return rawImages
        .filter((el) => {
        if (seenKeys.has(el.url)) {
            return false;
        }
        seenKeys.add(el.url);
        return el.url.toLowerCase().includes(ACCESSORY_KEY);
    })
        .sort((a, b) => getImageWeight(a.url) - getImageWeight(b.url));
}
export const prepareGalleryData = (rawVideos = [], rawImages = []) => {
    const images = resolveRelatedImages(rawImages);
    const imageComponents = images.map((image) => ({
        element: (React.createElement(Image, { key: image.id, src: image.url, ...image })),
        id: image.id,
        type: IMAGE,
    }));
    const videoComponents = rawVideos.reduce((acc, youtubeId) => {
        const { videoItem, videoThumbnail } = prepareVideo(youtubeId);
        acc.items.push({
            element: videoItem,
            id: youtubeId,
            type: VIDEO,
        });
        acc.thumbnails.push({
            element: videoThumbnail,
            id: youtubeId,
            type: VIDEO,
        });
        return acc;
    }, {
        items: [],
        thumbnails: [],
    });
    return {
        imagesList: [...videoComponents.items, ...imageComponents],
        lightboxImagesList: [...videoComponents.items, ...imageComponents],
        thumbnailsList: [...videoComponents.thumbnails, ...imageComponents],
        lightboxThumbnails: [...videoComponents.thumbnails, ...imageComponents],
    };
};
